import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    loadComponent: () => import('./layout/shell/shell.component').then(m => m.ShellComponent),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'brands',
        loadComponent: () => import('./features/brands/brands.component').then(m => m.BrandsComponent)
      },
      {
        path: 'content',
        loadComponent: () => import('./features/content/content.component').then(m => m.ContentComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./features/access/users/users.component').then(m => m.UsersComponent)
      },
      {
        path: 'api-access',
        loadComponent: () => import('./features/access/api-access/api-access.component').then(m => m.ApiAccessComponent)
      },
      {
        path: 'pages',
        loadComponent: () => import('./features/access/pages/pages.component').then(m => m.PagesComponent)
      },
      {
        path: 'config/app',
        loadComponent: () => import('./features/config/app-config/app-config-list.component').then(m => m.AppConfigListComponent)
      },
      {
        path: 'config/app/new',
        loadComponent: () => import('./features/config/app-config/app-config-detail.component').then(m => m.AppConfigDetailComponent)
      },
      {
        path: 'config/app/:id/edit',
        loadComponent: () => import('./features/config/app-config/app-config-detail.component').then(m => m.AppConfigDetailComponent)
      },
      {
        path: 'config/design',
        loadComponent: () => import('./features/config/design-config/design-config-list.component').then(m => m.DesignConfigListComponent)
      },
      {
        path: 'config/design/new',
        loadComponent: () => import('./features/config/design-config/design-config-detail.component').then(m => m.DesignConfigDetailComponent)
      },
      {
        path: 'config/design/:id/edit',
        loadComponent: () => import('./features/config/design-config/design-config-detail.component').then(m => m.DesignConfigDetailComponent)
      },
      {
        path: 'config/sections',
        loadComponent: () => import('./features/config/sections-config/sections-config-list.component').then(m => m.SectionsConfigListComponent)
      },
      {
        path: 'config/sections/new',
        loadComponent: () => import('./features/config/sections-config/sections-config-detail.component').then(m => m.SectionsConfigDetailComponent)
      },
      {
        path: 'config/sections/:id/edit',
        loadComponent: () => import('./features/config/sections-config/sections-config-detail.component').then(m => m.SectionsConfigDetailComponent)
      },
      {
        path: 'config/translation',
        loadComponent: () => import('./features/config/translation-config/translation-config-list.component').then(m => m.TranslationConfigListComponent)
      },
      {
        path: 'config/translation/new',
        loadComponent: () => import('./features/config/translation-config/translation-config-detail.component').then(m => m.TranslationConfigDetailComponent)
      },
      {
        path: 'config/translation/:id/edit',
        loadComponent: () => import('./features/config/translation-config/translation-config-detail.component').then(m => m.TranslationConfigDetailComponent)
      },
      {
        path: 'config/platform-mappings',
        loadComponent: () => import('./features/config/platform-mapping/platform-mapping-list.component').then(m => m.PlatformMappingListComponent)
      },
      {
        path: 'config/platform-mappings/new',
        loadComponent: () => import('./features/config/platform-mapping/platform-mapping-detail.component').then(m => m.PlatformMappingDetailComponent)
      },
      {
        path: 'config/platform-mappings/:id/edit',
        loadComponent: () => import('./features/config/platform-mapping/platform-mapping-detail.component').then(m => m.PlatformMappingDetailComponent)
      },
    ]
  },
  { path: '**', redirectTo: '' }
];
